import { X, ExternalLink } from 'lucide-react';
import { useEffect, useState } from 'react';

interface Props {
  url: string;
  onClose: () => void;
  productName?: string;
  productImage?: string;
  competitorName?: string;
  competitorPrice?: number;
}

export default function ViewUrlModal({ 
  url, 
  onClose,
  productName,
  productImage,
  competitorName,
  competitorPrice
}: Props) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg w-full max-w-2xl flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold text-gray-900">
            Visualizar Produto no {competitorName}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="p-6">
          <div className="flex flex-col items-center space-y-4">
            {productImage && (
              <div className="w-48 h-48 relative">
                <img
                  src={productImage}
                  alt={productName}
                  className="w-full h-full object-contain"
                />
              </div>
            )}
            
            <div className="text-center">
              <h3 className="text-lg font-medium text-gray-900">
                {productName}
              </h3>
              {competitorPrice && (
                <p className="mt-2 text-2xl font-bold text-primary">
                  {competitorPrice.toLocaleString('pt-PT', {
                    style: 'currency',
                    currency: 'EUR'
                  })}
                </p>
              )}
            </div>

            <a 
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-primary hover:bg-primary/90"
            >
              Ver no Site do {competitorName}
              <ExternalLink className="ml-2 h-5 w-5" />
            </a>

            <p className="text-sm text-gray-500 mt-4 text-center">
              Devido a restrições de segurança, não é possível visualizar o site diretamente.
              Clique no botão acima para abrir o produto no site do {competitorName}.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
